import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const getStudentTranscriptGradeLevelsQuery = gql`
  query getStudentTranscriptGradeLevels($id: ID!) {
    node(id: $id, type: STUDENT) {
      ... on Student {
        id
        transcriptSummary {
          id
          grades(filters: { includeHidden: true }) {
            id
            dataSource
            isHidden
            displaySequence
            grade {
              id
              name
              isCustom
            }
            school {
              id
              name
              sourceId
            }
            academicYear {
              id
              label
              sourceId
            }
            gradingPeriods {
              gradingPeriod {
                id
                name
              }
              displaySequence
            }
          }
        }
      }
    }
  }
`;

export const getTranscriptEntitiesQuery = gql`
  query getTranscriptEntities($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        transcriptGradingPeriods {
          id
          name
          isCustom
          displaySequence
          associations {
            totalCount
          }
          source {
            ... on AcademicTerm {
              id
              curriculumProgram {
                id
              }
              academicYear {
                id
              }
            }
          }
        }
        transcriptSchools(filters: { isCustom: true }) {
          id
          name
          displaySequence
          associations {
            totalCount
          }
        }
        transcriptAcademicYears(filters: { isCustom: true }) {
          id
          label
          displaySequence
          associations {
            totalCount
          }
        }
        transcriptGrades {
          id
          name
          isCustom
          displaySequence
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const getStudentYearGroup = gql`
  query getStudentYearGroup($id: ID!, $filters: GroupStudentFilter) {
    node(id: $id, type: YEAR_GROUP) {
      id
      ... on YearGroup {
        students(filters: $filters) {
          edges {
            node {
              id
              ...userNameFields
              profileImage
              sourceId
            }
          }
        }
      }
    }
  }
  ${userNameFragment}
`;
